import React from 'react';
import { useBrandProducts } from 'hooks/useBrandProducts';
import { useLandingPageRouteParams } from 'hooks/useLandingPageRouteParams';
import { AllProductsLandingPage } from './AllProductsLandingPage';
import { ProductLandingPage } from './ProductLandingPage';

const MainLandingPage = () => {
  const brandProducts = useBrandProducts();
  const { product } = useLandingPageRouteParams();

  if (product || brandProducts.length === 1) {
    const resolvedProduct = product ?? brandProducts[0];
    return <ProductLandingPage product={resolvedProduct} />;
  }

  return <AllProductsLandingPage />;
};

export default MainLandingPage;
